import apiService from './apiService';
import { API_ENDPOINTS } from '../config/api'; 

class BookingService {
  // Ajánlatkérés létrehozása (korábbi createBooking)
  async createBooking(bookingData) {
    try {
      const response = await apiService.post(API_ENDPOINTS.BOOKINGS.CREATE, bookingData);
      return response;
    } catch (error) {
      console.error('Error creating offer request:', error);
      throw error;
    }
  }

  // Ajánlat elküldése a szolgáltatótól
  async sendOffer(bookingId, offerPrice, offerMessage, offerExpiresAt = null, depositAmount = null, depositDeadline = null, fullPaymentDeadline = null) {
    try {
      const response = await apiService.post(API_ENDPOINTS.BOOKINGS.SEND_OFFER(bookingId), {
        offerPrice,
        offerMessage,
        offerExpiresAt,
        depositAmount: depositAmount || undefined,
        depositDeadline: depositDeadline || undefined,
        fullPaymentDeadline: fullPaymentDeadline || undefined,
      });
      return response;
    } catch (error) {
      console.error('Error sending offer:', error);
      throw error;
    }
  }

  // Ajánlat elfogadása az ügyféltől
  async acceptOffer(bookingId) {
    try {
      const response = await apiService.put(API_ENDPOINTS.BOOKINGS.ACCEPT_OFFER(bookingId));
      return response;
    } catch (error) {
      console.error('Error accepting offer:', error);
      throw error;
    }
  }

  // Ajánlat visszautasítása az ügyféltől
  async rejectOffer(bookingId, message = null) {
    try {
      const response = await apiService.put(API_ENDPOINTS.BOOKINGS.REJECT_OFFER(bookingId), { message });
      return response;
    } catch (error) {
      console.error('Error rejecting offer:', error);
      throw error;
    }
  }

  // Új ajánlat kérése az ügyféltől
  async requestNewOffer(bookingId, message, counterOfferPrice = null) {
    try {
      const body = {};
      if (message && message.trim()) body.message = message.trim();
      if (counterOfferPrice) body.counterOfferPrice = parseFloat(counterOfferPrice);
      const response = await apiService.post(API_ENDPOINTS.BOOKINGS.REQUEST_NEW_OFFER(bookingId), body);
      return response;
    } catch (error) {
      console.error('Error requesting new offer:', error);
      throw error;
    }
  }

  // Foglalások lekérdezése (ügyfél vagy szolgáltató számára)
  async getBookings(params = {}) {
    try {
      const queryParams = new URLSearchParams();
      
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      if (params.search) queryParams.append('search', params.search);
      if (params.status) queryParams.append('status', params.status);
      if (params.month) queryParams.append('month', params.month);
      if (params.dateFrom) queryParams.append('dateFrom', params.dateFrom);
      if (params.dateTo) queryParams.append('dateTo', params.dateTo);
      if (params.sortBy) queryParams.append('sortBy', params.sortBy);
      if (params.sortOrder) queryParams.append('sortOrder', params.sortOrder);
      if (params.include) queryParams.append('include', params.include);      
      // Az eventCoordinates include-ot a backend már automatikusan kezeli a getBookings-ban
      // queryParams.append('include', 'eventCoordinates'); 
      
      const response = await apiService.get(`${API_ENDPOINTS.BOOKINGS.LIST}?${queryParams.toString()}`);
      return response;
    } catch (error) {
      console.error('Error fetching bookings:', error);
      throw error;
    }
  }

  // Egyedi foglalás lekérdezése
  async getBookingById(id) {
    try {
      const response = await apiService.get(API_ENDPOINTS.BOOKINGS.DETAIL(id));
      return response;
    } catch (error) {
      console.error('Error fetching booking by ID:', error);
      throw error;
    }
  }

  // Foglalás frissítése (általános adatok, admin/provider)
  async updateBooking(id, updateData) {
    try {
      const response = await apiService.put(API_ENDPOINTS.BOOKINGS.UPDATE(id), updateData);
      return response;
    } catch (error) {
      console.error('Error updating booking:', error);
      throw error;
    }
  }

  // Foglalás státuszának frissítése (általános státuszokhoz, pl. COMPLETED, CANCELLED)
  async updateBookingStatus(bookingId, status, notes = '') {
    try {
      const response = await apiService.put(API_ENDPOINTS.BOOKINGS.STATUS(bookingId), { status, notes });
      return response;
    } catch (error) {
      console.error('Error updating booking status:', error);
      throw error;
    }
  }

  // Foglalás lemondása (most már az updateBookingStatus-t hívja)
  async cancelBooking(bookingId, notes = '') {
    try {
      const response = await this.updateBookingStatus(bookingId, 'CANCELLED', notes);
      return response;
    } catch (error) {
      console.error('Error cancelling booking:', error);
      throw error;
    }
  }

  // Foglalás törlése (admin)
  async deleteBooking(id) {
    try {
      const response = await apiService.delete(API_ENDPOINTS.BOOKINGS.DELETE(id));
      return response;
    } catch (error) {
      console.error('Error deleting booking:', error);
      throw error;
    }
  }

  // Szolgáltató elérhető időpontjai
  async getAvailableSlots(providerId, date) {
    try {
      const response = await apiService.get(`${API_ENDPOINTS.BOOKINGS.AVAILABLE_SLOTS(providerId)}?date=${date}`);
      return response;
    } catch (error) {
      console.error('Error fetching available slots:', error);
      throw error;
    }
  }
}

export default new BookingService();